import { useCourseCurrentPeriodDetails as useCoreCourseCurrentPeriodDetails } from '@ts-core/hooks/billingCourse';

import { getAcademyCourseCurrentPeriodDetailsQuery } from 'modules/academies/graphql/queries';

export default function useCourseCurrentPeriodDetails({ courseId }) {
  return useCoreCourseCurrentPeriodDetails({
    query: getAcademyCourseCurrentPeriodDetailsQuery,
    variables: { courseId },
    skip: !courseId,
  });
}
